import {Auth, mergeObjectIf} from "@/helpers"

export default {
  computed: {
    auth() {
      return this.$store.state.auth
    }
  },
  methods: {
    logout(redirect = false) {
      Auth.logout()
      this.$router.push({
        name: 'login',
        ...mergeObjectIf(redirect, {
          query: {redirect: this.$route.fullPath}
        })
      })
    }
  }
}
